import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { BarTitle } from "../components/CollapseBar";
import { Button } from "../components/ui/button";
import KasaDialog from "../components/KasaDialog";
import { useAuth } from "../context/AuthContext";
import { Wallet, Plus, Trash2 } from "lucide-react";

const tl = (n) => (Number(n) || 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 });
const today = () => new Date().toISOString().slice(0, 10);

export default function Kasa() {
  const { isAdmin } = useAuth();
  const [d1, setD1] = useState(today()); const [d2, setD2] = useState(today());
  const [data, setData] = useState({ items: [], toplam: {} });
  const [open, setOpen] = useState(false);
  const load = useCallback(() => api.get("/kasa", { params: { d1, d2 } }).then((r) => setData(r.data)), [d1, d2]);
  useEffect(() => { load(); }, [load]);
  const del = async (k) => { await api.delete(`/kasa/${k.id}`); load(); };
  return (
    <div data-testid="kasa-page" className="mw-fade-up space-y-3">
      <BarTitle><h1 className="font-head flex items-center gap-2 text-2xl font-bold text-white"><Wallet className="h-6 w-6 text-emerald-400" /> KASA</h1></BarTitle>
      <div className="flex flex-wrap items-center gap-2 text-sm text-slate-300">
        <input data-testid="kasa-d1" type="date" value={d1} onChange={(e) => setD1(e.target.value)} className="h-9 rounded border border-slate-700 bg-slate-800 px-2 text-slate-100" />
        <input data-testid="kasa-d2" type="date" value={d2} onChange={(e) => setD2(e.target.value)} className="h-9 rounded border border-slate-700 bg-slate-800 px-2 text-slate-100" />
        {["NAKİT", "HAVALE", "ÇEK", "GENEL"].map((k) => <span key={k} data-testid={`kasa-total-${k}`} className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-1 text-xs font-bold">{k}: {tl(data.toplam[k])}</span>)}
        <Button data-testid="kasa-new" onClick={() => setOpen(true)} className="ml-auto bg-emerald-600 text-white hover:bg-emerald-700"><Plus className="mr-1 h-4 w-4" /> TAHSİLAT / ÖDEME</Button>
      </div>
      <div className="overflow-auto rounded-xl border border-slate-800 bg-slate-900">
        <table className="w-full text-[12px] text-slate-200">
          <thead><tr className="border-b border-slate-700 text-left text-slate-400">{["TARİH", "TÜR", "TİP", "YÖNTEM", "TUTAR", "MÜŞTERİ", "TAKİP NO", "SÜRÜCÜ", "ÇEK BİLGİSİ", "AÇIKLAMA", ""].map((h) => <th key={h} className="px-2 py-1.5">{h}</th>)}</tr></thead>
          <tbody>
            {data.items.length === 0 && <tr><td colSpan={11} className="px-2 py-6 text-center text-slate-500">KAYIT YOK</td></tr>}
            {data.items.map((k) => (
              <tr key={k.id} data-testid={`kasa-row-${k.id}`} className="border-b border-slate-800">
                <td className="px-2 py-1">{k.tarih}</td>
                <td className={`px-2 py-1 font-bold ${k.tur === "TAHSİLAT" ? "text-emerald-300" : "text-rose-300"}`}>{k.tur}</td>
                <td className="px-2 py-1">{k.odeme_tipi}</td><td className="px-2 py-1">{k.yontem}</td><td className="px-2 py-1 font-bold">{tl(k.tutar)}</td>
                <td className="px-2 py-1">{k.cari_ad}</td><td className="px-2 py-1 font-mono">{k.takip_no}</td><td className="px-2 py-1">{k.surucu}</td>
                <td className="px-2 py-1">{k.yontem === "ÇEK" ? `${k.cek_no} · ${k.cek_banka} · ${k.cek_vade}` : ""}</td><td className="px-2 py-1">{k.aciklama}</td>
                <td className="px-2 py-1">{isAdmin && <button data-testid={`kasa-del-${k.id}`} onClick={() => del(k)} className="text-slate-500 hover:text-rose-400"><Trash2 className="h-4 w-4" /></button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <KasaDialog open={open} onOpenChange={setOpen} onDone={load} />
    </div>
  );
}
